import React from 'react';
import BounceLoader from 'react-spinners/BounceLoader';

class ApiUiController extends React.Component {
  render() {
    return this.props.inApiCall ?
      <BounceLoader size={70} color="blue" /> : this.props.children;
  }
}
export default ApiUiController;